import clsx from "clsx";
import { useEffect } from "react";
import {
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import AddInsurer from "../pages/AddInsurer";
import Agent from "../pages/Agent";
import CreateChase from "../pages/CreateChase";
import Providers from "../pages/Providers";
import ChaseList from "../pages/ChaseList";
import Dashboard from "../pages/Dashboard";
import LeftSidebar from "./LeftSidebar";
import Auth from "../pages/Auth";
import ResetPassword from "../pages/ResetPassword";
import GraphProvider from "../providers/graphs-provider";
import LowScreen from "./low-screen";
import Chat from "../pages/Chat";
import ChaseLogs from "../pages/chaseLogs";
import BrandedLogo from "./branded-logo";
import { useSidebar } from "../store/use-sidebar";

function MainComponent() {
  const location = useLocation();
  const { collapsed, mobileOpen, setMobileOpen } = useSidebar();
  const hideSideBarRoutes = ["/createChase", "/createInsurer", "/auth", "/reset", "/chat"]
  const showSideBar = !hideSideBarRoutes?.includes(location.pathname);

  // Mobile drawer: close on navigation
  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname, setMobileOpen]);

  // Mobile drawer: lock page scroll while open
  useEffect(() => {
    if (!mobileOpen) return;
    const previous = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = previous;
    };
  }, [mobileOpen]);

  return (
    <GraphProvider>
      <LowScreen />
      <div className="flex min-h-screen bg-background">
        {showSideBar ? (
          <>
            <div
              className={clsx(
                "shrink-0 min-h-screen sticky top-0 transition-[width] duration-300 ease-out",
                collapsed ? "w-[76px]" : "w-[264px]",
                "smallTablet:fixed smallTablet:inset-y-0 smallTablet:left-0 smallTablet:z-[70] smallTablet:w-[280px] smallTablet:max-w-[85vw] smallTablet:min-h-0 smallTablet:h-[100dvh] smallTablet:transition-transform smallTablet:shadow-overlay",
                mobileOpen ? "smallTablet:translate-x-0" : "smallTablet:-translate-x-full smallTablet:shadow-none",
              )}
            >
              <LeftSidebar />
            </div>
            <div
              aria-hidden="true"
              onClick={() => setMobileOpen(false)}
              className={clsx(
                "hidden fixed inset-0 z-[65] bg-[color:var(--shadow-modal-scrim)] backdrop-blur-sm",
                mobileOpen && "smallTablet:block",
              )}
            />
          </>
        ) : null}
        <div
          className={clsx(
            "flex-1 min-w-0 min-h-screen h-full bg-background",
          )}
        >
          {showSideBar ? (
            <div className="hidden smallTablet:flex sticky top-0 z-30 h-14 items-center gap-3 px-4 bg-surface border-b border-edge shadow-card">
              <button
                type="button"
                onClick={() => setMobileOpen(true)}
                aria-label="Open menu"
                className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg border border-edge bg-overlay text-light-gray hover:text-text-primary transition-colors"
              >
                <FontAwesomeIcon icon={faBars} className="text-sm" />
              </button>
              <BrandedLogo className="w-[96px] shrink-0 opacity-95" />
            </div>
          ) : null}
          <Routes>
            <Route path="/" element={
              <Dashboard />
            } />
            <Route path="/chaselist" element={<ChaseList />} />
            <Route path="/chase/:id" element={<ChaseList />} />
            <Route path="/my-customers" element={<ChaseList />} />
            <Route path="/customer-archives" element={<ChaseList />} />
            <Route path="/providers" element={<Providers />} />
            <Route path="/createChase" element={<CreateChase />} />
            <Route path="/createInsurer" element={<AddInsurer />} />
            <Route path="/agents" element={<Agent />} />
            <Route path="/auth" element={<Auth />} />
            <Route path="/reset" element={<ResetPassword />} />
            <Route path="/chat" element={<Chat />} />
            <Route path="/chaselogs/:id" element={<ChaseLogs />} />
          </Routes>
        </div>
      </div>
    </GraphProvider>
  );
}

export default MainComponent;
